
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/security-score",
      function () {
        return require("private-next-pages/sign/security-score.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/security-score"])
      });
    }
  